import {Grid, Card, CardContent, Typography, Theme, Skeleton} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {DeleteIconButton, EditIconButton} from 'components/buttons';
import {AVATAR_SIZE} from './AdminBookmarkCard';

const useStyles = makeStyles((theme : Theme) => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      maxHeight: 117,
    }
  },
  cardContent: {
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      maxHeight: 117,
    }
  },
  avatar: {
    boxShadow: theme.shadows[1],
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
  },
  name: {
    fontWeight: '500',
  }
}), {name: 'AdminBookmarkCardSkeleton'});

const AdminBookmarkCardSkeleton = () => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container wrap='nowrap' spacing={2} alignItems='center'>
          <Grid item>
            <Skeleton variant="circular" width={AVATAR_SIZE} height={AVATAR_SIZE} />
          </Grid>
          <Grid item xxs zeroMinWidth>
            <Grid container spacing={1}>
              <Grid item zeroMinWidth xs={12}>
                <Typography className={classes.name} variant='h5' noWrap>
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item zeroMinWidth xs={12}>
                <Typography noWrap>
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item zeroMinWidth xs={12}>
                <Grid container spacing={1} justifyContent='flex-end'>
                  <Grid item>
                    <EditIconButton disabled />
                  </Grid>
                  <Grid item>
                    <DeleteIconButton disabled />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default AdminBookmarkCardSkeleton;